import { render, staticRenderFns } from "./unload.vue?vue&type=template&id=1c8a1a2a&scoped=true&"
import script from "./unload.vue?vue&type=script&lang=js&"
export * from "./unload.vue?vue&type=script&lang=js&"
import style0 from "./unload.vue?vue&type=style&index=0&id=1c8a1a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a1a2a",
  null
  
)

export default component.exports